
    import '/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/pages/reference/operate/index.md?watch=parent';
    export const demoIndex = {
  ids: ["pages-pages-reference-operate-demo-base","pages-pages-reference-operate-demo-vertical","pages-pages-reference-operate-demo-disabled","pages-pages-reference-operate-demo-hide","pages-pages-reference-operate-demo-custom"],
  getter: () => import(/* webpackChunkName: "meta__p" */'/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/pages/reference/operate/index.md?type=demo')
};